module.exports = __webpack_public_path__ + "img/00023.98181ad4.webp";